module.exports = __webpack_public_path__ + "img/logo.918ffd4d.png";